import React from "react";
import "./btt.css";
function ScrollButton() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="d-grid gap-2 col-3 col-md-1 mx-auto mb-5 mb-md-0">
      <button type="button" className="btn btn-btt" onClick={scrollToTop}>
        Back to top
      </button>
    </div>
  );
}

export default ScrollButton;
